import { useEffect, useState } from 'react';
import { getOperateType } from '@meitu/saas-editor-core/es/framework';
import { ITouchKitEvent } from '@meitu/saas-editor-core/es/utils/event-kit';
import { useMoveEventListener } from '@meitu/saas-editor-ui/es/hooks/use-move-event-listener';
import { editor } from '@/instance';
import { useStoreActions, useStoreState } from '@/store';
import { getImageExpendSize } from '../utils';

const useMoveImage = (scale: number, canMove: boolean) => {
    const [offset, setOffset] = useState({
        offsetX: 0,
        offsetY: 0,
    });
    useMoveEventListener((e: ITouchKitEvent) => {
        e.originEvent.preventDefault();

        if (!canMove) {
            return;
        }
        const targetType = getOperateType(e.target);
        if (targetType !== 'AIExpendImageContent') {
            return;
        }

        setOffset({
            offsetX: e.deltaX / scale,
            offsetY: e.deltaY / scale,
        });
    });

    return offset;
};

export default useMoveImage;
